<template>
  <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="HDFS文件" name="hdfs">
      <a href="http://123.57.105.95:9088/filebrowser/#/user/hadoop" target="_blank">跳转到HDFS</a>
      <!--      <HDFSManage v-if="load.hdfs"></HDFSManage>-->
    </el-tab-pane>
    <el-tab-pane label="SparkNotebook" name="spark">
      <!--      <SparkManager v-if="load.spark"></SparkManager>-->
      <a href="http://123.57.105.95:9001" target="_blank">跳转到SparkNotebook</a>
    </el-tab-pane>
    <el-tab-pane label="HIVE" name="hive">
      <!--      <HiveManager v-if="load.hive"></HiveManager>-->
      <a href="http://123.57.105.95:9088/notebook/editor?type=hive" target="_blank">跳转到HIVE</a>
    </el-tab-pane>
    <el-tab-pane label="OLTP" name="oltp">
      <a href="http://123.57.105.95:9603/" target="_blank">跳转到oltp系统</a>
    </el-tab-pane>

  </el-tabs>
</template>

<script>
// import HDFSManage from "@/views/data_factory/HDFSManage";
// import HiveManager from "@/views/data_factory/HiveManager";
// import SparkManager from "@/views/data_factory/SparkManager";

export default {
  name: "DataFactory",
  // components: {
  //   HDFSManage,
  //   HiveManager,
  //   SparkManager,
  // },
  data() {
    return {
      activeName: 'hdfs',
      load: {
        hdfs: true,
        hive: false,
        spark: false,
        oltp: false,
      }
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(event)
      if (this.load[tab.name] === false) {
        this.load[tab.name] = true
      }
    }
  }
}
</script>

<style scoped>

</style>
